// extracted by mini-css-extract-plugin
export var dropdown = "_ro-0";
export var imageWrapper = "_ro-3";
export var itemNameContainer = "_ro-1";
export var productImage = "_ro-2";
export var spinnerWrapper = "_ro-4";